import React from "react";

interface IProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
}
const Image: React.FC<IProps> = ({ src, ...props }) => (
  <img src={src} alt="" {...props} />
);

export default Image;
